import React, { useEffect, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import { Externo, Usuario } from "../../../services/v2/wappdrive.service";
import WappIcono from "../../../components/wappIcono";
import { errorTexto } from "./dialogos";
import { cuandoFue } from "./bitacora";

const inicial = (n: string) => n.split(" ").filter(Boolean).slice(0, 2).map((x) => x[0]).join("").toUpperCase();
/** Primer nombre + primer apellido (como el resto de WAPP en pantallas chicas); el completo queda en el title. */
const corto = (n: string) => { const p = n.split(" ").filter(Boolean); return p.length <= 2 ? n : p[0] + " " + p[p.length >= 4 ? 2 : 1]; };

/**
 * Compartir con externos (solo Super Admin; Esteban, 2026-10-09): quién, además de Super Admin, puede compartir un
 * archivo con "Cualquier persona con el enlace". Agregar y quitar queda en la Bitácora.
 */
const Externos: React.FC<{ campusId: number; onBitacora: () => void }> = ({ campusId, onBitacora }) => {
	const http = HttpManager.getInstance().wappdriveService;
	const [personas, setPersonas] = useState<Externo[] | null>(null);
	const [supers, setSupers] = useState<string[]>([]);
	const [q, setQ] = useState("");
	const [res, setRes] = useState<Usuario[] | null>(null);
	const [quitar, setQuitar] = useState<number | null>(null);
	const [ocupado, setOcupado] = useState<number | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);

	const poner = (d: { personas: Externo[]; super_admins: string[] }) => { setPersonas(d.personas); setSupers(d.super_admins); };
	useEffect(() => { http.externos(campusId).then((r) => poner(r.data)).catch((e) => setError(errorTexto(e))); }, [campusId]);
	useEffect(() => {
		if (q.trim().length < 2) { setRes(null); return; }
		const t = setTimeout(() => http.usuarios(campusId, q.trim()).then((r) => setRes(r.data.usuarios)).catch((e) => setError(errorTexto(e))), 250);
		return () => clearTimeout(t);
	}, [q]);

	const agregar = async (u: Usuario) => {
		setError(null); setAviso(null); setOcupado(u.id);
		try { const r = await http.autorizarExterno(campusId, u.id); poner(r.data); setQ(""); setRes(null); setAviso(corto(u.name) + " ya puede descargar a su computadora y compartir fuera de Washington Academy."); }
		catch (e) { setError(errorTexto(e)); } finally { setOcupado(null); }
	};
	const confirmarQuitar = async (p: Externo) => {
		setError(null); setAviso(null); setOcupado(p.id);
		try { const r = await http.desautorizarExterno(campusId, p.id); poner(r.data); setAviso(corto(p.name) + " ya no puede descargar a su computadora ni compartir fuera. Los enlaces que ya compartió siguen abiertos hasta que alguien los quite."); }
		catch (e) { setError(errorTexto(e)); } finally { setOcupado(null); setQuitar(null); }
	};
	const ya = new Set((personas || []).map((p) => p.id));

	return (
		<div className="wd-ext">
			<section className="wd-ext-intro">
				<span className="wd-ext-ico"><WappIcono n="world" /></span>
				<div>
					<b>Quién Puede Sacar Archivos de WAPP</b>
					<p>Descargan a su computadora y comparten fuera de Washington Academy; los demás guardan en su WappDrive. Todo queda en la <button className="wd-ext-link" onClick={onBitacora}>Bitácora</button>.</p>
					<p className="wd-ext-super"><WappIcono n="lock" /> <span>Super Admin siempre puede{supers.length ? ": " + supers.join(", ") : ""}.</span></p>
				</div>
			</section>

			<section className="wd-ext-agregar">
				<div className="wd-busca wd-ext-busca" role="search">
					<WappIcono n="search" className="wd-busca-lupa" />
					<input type="text" placeholder="Agregar persona por nombre o correo" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Buscar persona para autorizar" />
					{q ? <button type="button" className="wd-busca-x" onClick={() => setQ("")} aria-label="Borrar búsqueda"><WappIcono n="x" /></button> : null}
				</div>
				{res ? (
					<div className="wd-ext-res">
						{res.map((u) => (
							<div key={u.id} className="wd-ext-persona">
								<span className="wd-avatar">{inicial(u.name)}</span>
								<span className="wd-ext-txt"><b title={u.name}>{u.name}</b><small>{u.email}</small></span>
								{ya.has(u.id) ? <span className="wd-chip">Ya autorizada</span>
									: <button className="wd-btn chico pri" disabled={ocupado === u.id} onClick={() => agregar(u)}><WappIcono n="plus" /> Autorizar</button>}
							</div>
						))}
						{!res.length ? <div className="wd-tenue wd-ext-nada">Nadie del personal coincide con “{q.trim()}”.</div> : null}
					</div>
				) : null}
				{q && q.trim().length < 2 ? <small className="wd-tenue">Escribe al menos 2 letras.</small> : null}
			</section>

			{error ? <div className="wd-aviso" onClick={() => setError(null)}>{error}</div> : null}
			{aviso ? <div className="wd-aviso ok" onClick={() => setAviso(null)}>{aviso}</div> : null}

			<div className="wd-ext-tit">
				<span>Autorizadas</span>
				<span className="wd-tenue">{personas ? personas.length + (personas.length === 1 ? " persona" : " personas") : ""}</span>
			</div>
			<div className="wd-tabla wd-ext-lista">
				{personas === null ? <div className="wd-vacio">Cargando…</div> : null}
				{personas?.map((p) => (
					<div key={p.id} className={"wd-ext-fila" + (quitar === p.id ? " confirmando" : "")}>
						<span className="wd-avatar">{inicial(p.name)}</span>
						<span className="wd-ext-txt">
							<b title={p.name}>{p.name}</b>
							<small title={p.email}>{p.email}</small>
						</span>
						<span className="wd-ext-roles" title={p.roles || ""}>{p.roles || "—"}{!Number(p.habilitada) ? <span className="wd-chip oro">Cuenta desactivada</span> : null}</span>
						<span className="wd-ext-cuando"><small>Autorizó {p.autorizo ? corto(p.autorizo) : "Dirección"}</small><small>{p.created_at ? cuandoFue(p.created_at) : ""}</small></span>
						{quitar === p.id ? (
							<span className="wd-ext-confirma">
								<span>¿Quitarle el permiso?</span>
								<button className="wd-btn chico" onClick={() => setQuitar(null)}>Cancelar</button>
								<button className="wd-btn chico pri" disabled={ocupado === p.id} onClick={() => confirmarQuitar(p)}>Sí, quitar</button>
							</span>
						) : (
							<span className="wd-ext-acc"><button className="wd-btn chico" onClick={() => { setQuitar(p.id); setAviso(null); }}>Quitar</button></span>
						)}
					</div>
				))}
				{personas && !personas.length ? <div className="wd-vacio">Por ahora solo Super Admin puede sacar archivos de WAPP.</div> : null}
			</div>
		</div>
	);
};

export default Externos;
